import { ActiveDriver } from '../models';
import DriverMap from './DriverMap';

interface DriverMonitoringGridProps {
  drivers: ActiveDriver[];
}

const DriverMonitoringGrid = ({ drivers }: DriverMonitoringGridProps) => {
  const driverCount = drivers.length;

  const getGridClasses = () => {
    switch (driverCount) {
      case 1:
        return 'grid-cols-1';
      case 2:
        return 'grid-cols-1 lg:grid-cols-2';
      case 3:
        return 'grid-cols-1 lg:grid-cols-3';
      case 4:
        return 'grid-cols-1 lg:grid-cols-2';
      default:
        return 'grid-cols-1';
    }
  };

  return (
    <div
      className={`grid ${getGridClasses()} gap-4 w-full`}
      style={{
        gridAutoRows: driverCount === 1 ? '1fr' : 'minmax(400px, 1fr)',
        height: '100%',
      }}
    >
      {drivers.map((driver) => (
        <div
          key={driver.driverId}
          className='w-full h-full min-h-[400px] rounded-lg overflow-hidden shadow-lg border border-gray-200'
        >
          <DriverMap driver={driver} />
        </div>
      ))}
    </div>
  );
};

export default DriverMonitoringGrid;
